export const SIZE = {
  padding: 32,
  title: {
    minWidth: 222,
    maxWidth: 328,
  },
  content: {
    maxHeight: 40,
  },
  blank: {
    width: 28,
  },
  image: {
    width: 232,
  },
};